import React__default, { useContext } from 'react';
import { a as LocalizationContext } from '../../LocalizationContext-a82461b5.js';
import { L as Label, b as LabelColors, a as LabelTypography } from '../../index-6420013c.js';
import Icon, { IconTypes, IconColors } from '../../ui/Icon.js';
import '../../stringSet-b60e9529.js';
import '../../index-6add7940.js';
import 'prop-types';
var UnreadCount = function UnreadCount(_ref) {
  var _time$toString, _time$toString$call;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$time = _ref.time,
    time = _ref$time === void 0 ? '' : _ref$time,
    onClick = _ref.onClick;
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  var timeArray = (time === null || time === void 0 ? void 0 : (_time$toString = time.toString) === null || _time$toString === void 0 ? void 0 : (_time$toString$call = _time$toString.call(time)) === null || _time$toString$call === void 0 ? void 0 : _time$toString$call.split(' ')) || [];
  timeArray === null || timeArray === void 0 ? void 0 : timeArray.splice(-2, 0, stringSet.CHANNEL__MESSAGE_LIST__NOTIFICATION__ON);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-notification".concat(count < 1 ? '--hide' : '', " ").concat(className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-notification__text",
    color: LabelColors.ONCONTENT_1,
    type: LabelTypography.CAPTION_2
  }, "".concat(count, " "), stringSet.CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE, " ".concat(timeArray.join(' '))), /*#__PURE__*/React__default.createElement(Icon, {
    width: "24px",
    height: "24px",
    type: IconTypes.CHEVRON_DOWN,
    fillColor: IconColors.CONTENT
  }));
};
export { UnreadCount as default };